import { SortableContext } from '@dnd-kit/sortable'

function SortableContextContainerProvider({ children, ...restProps }) {
  return <SortableContext {...restProps}>{children}</SortableContext>
}

export default SortableContextContainerProvider
